/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * TableEmptyState
 *
 * Shown when the table has no rows.
 *
 * Props:
 *  message    {string}  — custom message
 *  icon       {node}    — override icon
 *  colSpan    {number}  — number of columns (for the cell)
 */
const TableEmptyState = ({
  message = 'Aucune donnée disponible',
  icon,
  colSpan = 10,
}) => (
  <tr>
    <td colSpan={colSpan}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: '60px',
          gap: '12px',
        }}
      >
        {icon || (
          <InboxOutlinedIcon sx={{ fontSize: 48, color: '#CBD5E0' }} />
        )}
        <Typography sx={{ fontSize: '14px', color: '#A0AEC0', fontWeight: 500 }}>
          {message}
        </Typography>
      </Box>
    </td>
  </tr>
);

export default TableEmptyState;
